import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import "../3d-game/component/common/resultPopUp.scss";
import { SocketState } from "../context/SocketProvider";
import ModalContainer from "../2d-game/modals/ModalContainer";

function ResultPopupPana() {
  const { socket } = SocketState();
  const [resultDates, setResultDates] = useState([]);
  const [resultTime, setResultTime] = useState({});
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const container = useRef(null);

  // capture result history (self-contained)
  useEffect(() => {
    if (!socket) return;
    const onRes = (res) => {
      if (res?.en === "PLAY_MATKA_RESULTS_HISTORY" && !res.err) {
        setResultDates(res.data?.dates || []);
        setResultTime(res.data?.time_result || {});
      }
    };
    socket.on("res", onRes);
    return () => socket.off("res", onRes);
  }, [socket]);

  useEffect(() => {
    if (!socket) return;
    socket.emit("req", {
      en: "PLAY_MATKA_RESULTS_HISTORY",
      data: { date: moment(fromDate, "YYYY-MM-DD").format("DD-MM-YYYY") },
    });
  }, [fromDate, socket]);

  return (
    <ModalContainer title={"Result"} navigation={"/pana-game"}>
      <div className="myaccount_content">
        <div className="date_search_section flex items-center pana-result-filter">
          <div className="w-full flex">
            <div className="w-1/4 px-4 pana-date-wrap">
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="from">From</label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="from"
                  type="date"
                  placeholder="from"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                  max={moment().format("YYYY-MM-DD")}
                  min={"2023-04-01"}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="history_table_div h-[calc(100vh-35vh)] overflow-y-auto pb-16" ref={container}>
          <table className="table table-borderless history_table">
            <thead className="sticky top-0">
              <tr>
                <th className="text-center">TIME</th>
                {resultDates.length > 0 &&
                  resultDates.map((date, index) => (
                    <th key={index} className="text-center">{date}</th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {resultDates.length ? (
                Object.keys(resultTime).map((timeArray, timeArrayIndex) => (
                  <tr key={timeArrayIndex}>
                    <td className="text-center">{timeArray}</td>
                    {resultTime[timeArray].map((value, valueIndex) => (
                      <td key={valueIndex}>
                        <div className="result_his_line">
                          {value &&
                            (value.includes("&")
                              ? value.split("&").map((pair, idx) => {
                                  const parts = pair.split("=");
                                  return (
                                    <div key={idx} className={`result_span_10_series text-center three_game_result_his${idx + 1}`}>
                                      {parts[0]} - {parts[1] || ""}
                                    </div>
                                  );
                                })
                              : (() => {
                                  const parts = value.split("=");
                                  return (
                                    <div className="result_span_10_series text-center">
                                      {parts[1] || value}
                                    </div>
                                  );
                                })())}
                        </div>
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="text-center">-</td>
                  <td colSpan={7} className="text-center">No result Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </ModalContainer>
  );
}

export default ResultPopupPana;
